import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Environment,
  MagazziniSetLocazioniTable,
  MagazziniSettoriLocazioni,
  ModelNumStr,
  ModelNumStrBoolGroupDefault,
  ModelNumStrNav,
} from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class MagazziniSettoriLocazioniService extends CrudGenericsService<MagazziniSettoriLocazioni, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniSettoriLocazioni`);
    this.base = `${env.apiUrl}/api/MagazziniSettoriLocazioni/`;
  }

  Get4Select_SettoreMagazzinoNavigation(): Observable<ModelNumStrNav[]> {
    const u = `${this.base}Get4Select_SettoreMagazzinoNavigation`;
    return this.http.get<ModelNumStrNav[]>(u);
  }

  Get4Select_BySettore(id: number): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_BySettore?id=${id}`;
    return this.http.get<ModelNumStr[]>(u);
  }

  Get4SelectAllBoolGroup_SuggestArt(id: number): Observable<ModelNumStrBoolGroupDefault> {
    const u = `${this.base}Get4SelectAllBoolGroup_SuggestArt?id=${id}`;
    return this.http.get<ModelNumStrBoolGroupDefault>(u);
  }

  Get4SelectBoolGroup_FilterByArt(id: number): Observable<ModelNumStrBoolGroupDefault> {
    const u = `${this.base}Get4SelectBoolGroup_FilterByArt?id=${id}`;
    return this.http.get<ModelNumStrBoolGroupDefault>(u);
  }

  /*
  Get4SelectGroup_WithMagArt(): Observable<MagSetLocGroupDefault> {
    const url = this.base + 'Get4SelectGroup_WithMagArt';
    return this.http.get<MagSetLocGroupDefault>(`${url}`);
  }

  Get4SelectGroup_WithMagArt_ByArt(id: number): Observable<MagSetLocGroupDefault> {
    const url = this.base + 'Get4SelectGroup_WithMagArt_ByArt?id=' + id;
    return this.http.get<MagSetLocGroupDefault>(`${url}`);
  }*/

  GetMagaziniSettoriLocazioniTable(): Observable<MagazziniSetLocazioniTable[]> {
    const u = `${this.base}GetMagaziniSettoriLocazioniTable`;
    return this.http.get<MagazziniSetLocazioniTable[]>(u);
  }
}
